import logo from '../assets/img/logo.png';

export default function Header( {t, isFullNav=true} ) {
    return (<header >

            </header>
    )
}